module.exports = __webpack_public_path__ + "img/33s.2740baeb.png";